import React from 'react';
import Login from 'pages/Login';
import SignUp from 'pages/Signup';
import WorkingAreasPage from 'pages/WorkingAreas';
import ComplianceEst from 'pages/ClientRequirements';
import GapsAndAuditFindings from 'pages/GapsAndAuditFindings';
import SolutionDefinition from 'pages/SolutionDefinition';
import EvidenceDefinition from 'pages/EvidenceDefinition';
import TasksDefinition from 'pages/TasksDefinition';
import AuditFindingsManagement from 'pages/AuditFindings/AuditFindingsManagement';
import CategoryManagement from 'pages/AuditFindings/CategoryManagement';
import ProductManagement from 'pages/AuditFindings/ProductManagement';
import SolutionTypeManagement from 'pages/AuditFindings/SolutionTypeManagement';
import TaskTypeManagement from 'pages/AuditFindings/TaskTypeManagement';
import ForgotPass from 'pages/ForgotPass';
import ResetPass from 'pages/ResetPass';
import VerifyLogin from 'pages/VerifyLogin';
import Reporting from 'pages/Reporting';
import ControlReport from 'pages/Reporting/ControlReport/ControlReport';
import GapsEvidences from 'pages/Reporting/GapsEvidences/GapsEvidences';
import BusinessRulesAuditFindings from 'pages/Reporting/BusinessRulesAuditFindings/BusinessRulesAuditFindings';
import Library from 'pages/Library';
import LibraryReporting from 'pages/Library/LibraryReporting';
import LibraryDataEntry from 'pages/Library/LibraryDataEntry';
import DataEntryTable from 'pages/Library/DataEntryTable';
import MainLayout from 'pages/AuditFindings/MainLayout';
import UserAccess from 'pages/UserAccess/UserAccess';
import Risks from 'pages/InternalControlsMain/Risks';
import Controls from 'pages/InternalControlsMain/Controls';
import ControlsTesting from 'pages/InternalControlsMain/ControlsTesting';
import Processes from 'pages/InternalControlsMain/Processes';
import InternalControlsDND from 'pages/InternalControlsMain/InternalControlsDND';
import SuperAdminRedirect from 'components/SuperAdmin/SuperAdminRedirect';
import ProcessesL1 from 'pages/InternalControlsMain/ProcessesL1/Processes';
import ProcessesL2 from 'pages/InternalControlsMain/ProcessesL2/Processes';
import ProcessesL3 from 'pages/InternalControlsMain/ProcessesL3/Processes';
import ReportingRisksAndControls from 'pages/Reporting/ReportingRisksAndControls';
import Allocation from 'pages/InternalControlsMain/Allocation/Allocation';
import AuditFindingWorkflow from 'pages/AuditFindings/AuditFindingWorkflow';
import DataManagementWorkflow from 'pages/AuditFindings/DataManagementWorkflow';
import AuditFindingsMapping from 'pages/AuditFindings/AuditFindingsMapping';
import DesignEffectivenessTesting from 'pages/InternalControlsMain/ControlsTesting/DesignEffectiveness/DesignEffectivenessTesting';
import ProcessAllocation from 'pages/InternalControlsMain/ProcessAllocation/ProcessAllocation';
import Dashboard from 'pages/Dashboard/Dashboard';
import WhoAmI from 'pages/WhoAmI/WhoAmICards/WhoAmI';
import OrganizationalContext from 'pages/WhoAmI/OrganizationalContext/OrganizationalContext';
import WhoAmIAllocation from 'pages/WhoAmI/Allocation/WhoAmIAllocation';
import ControlAttestationTesting from 'pages/InternalControlsMain/ControlsTesting/ControlAttestation/ControlAttestationTesting';
import WhoAmIAllocationUsers from 'pages/WhoAmI/AllocationUsers/WhoAmIAllocationUsers';
import GapsAuditSolutionsReport from 'components/DependencyTrees/BRUGapAuditSolutions/GapsAuditSolutionsReport';
import BRUEvidencesReport from 'components/DependencyTrees/BRUEvidences/EvidencesReport';
import Dependencies from 'pages/Dependencies/Dependencies';
import ProcessesReport from 'components/DependencyTrees/BPRRiskControls/ProcessesReport';
import BusinessProcessReport from 'components/DependencyTrees/BPRProcesses/BusinessProcessReport';
import DependenciesBPR from 'pages/DependenciesBPR/Dependencies';

export const MODULE_ROUTES = {
  Compliance: [
    '/workingAreaDetails/rules-to-evidence',
    '/complianceEst/clientReq',
    '/complianceEst/gapsAndAuditFindings',
    '/complianceEst/solutionDefinition',
    '/complianceEst/tasksDefinition',
    '/complianceEst/evidenceDefinition',
    '/dataManagement/auditFindings',
    '/dataManagement/category',
    '/dataManagement/product',
    '/reporting',
    '/reporting/gaps-evidences',
    '/reporting/business-rules-audit-findings',
    '/dataManagement',
    '/dataManagement/solutionType',
    '/dataManagement/taskType',
    '/audit_findings_workflow',
    '/data_management_workflow',
    '/audit_findings_table',
    '/compliance_establishment',
    '/compliance/dashboard',
    '/dependencies/gaps_audits_solutions',
    '/dependencies/evidences'
  ],

  'Risk & Control': [
    '/reporting/control-report',
    '/internal_controls',
    '/controlsAndRiskAllocation/risks',
    '/controlsAndRiskAllocation/controls',
    '/controlsAndRiskAllocation/businessProcesses',
    '/risk-controls/dnd',
    '/controlsAndRiskAllocation/controlsTesting',
    '/controlsAndRiskAllocation/businessProcessesL1',
    '/controlsAndRiskAllocation/businessProcessesL2',
    '/controlsAndRiskAllocation/businessProcessesL3',
    '/risk-controls/reportings',
    '/controlsAndRiskAllocation/allocation',
    '/risk-controls/testings',
    '/risk-controls/inventories',
    '/risk-controls/allocation',
    '/controlsAndRiskAllocation/controlsTestingDesignEffectiveness',
    '/controlsAndRiskAllocation/processAllocation',
    'controlsAndRiskAllocation/controlAttestation',
    '/dependency_bpr/risks_controls_gaps',
    '/dependency_bpr/processes',
    '/dependency_bpr'
  ]
};

const routes = [
  {
    id: 1,
    path: '/',
    private: false,
    component: () => <Login />
  },
  {
    id: 2,
    path: '/signup',
    private: false,
    component: () => <SignUp />
  },
  {
    id: 3,
    path: '/working_area',
    private: true,
    component: () => <WorkingAreasPage />
  },
  {
    id: 4,
    path: '/complianceEst/clientReq',
    private: true,
    component: () => <ComplianceEst />
  },
  {
    id: 5,
    path: '/complianceEst/gapsAndAuditFindings',
    private: true,
    component: () => <GapsAndAuditFindings />
  },
  {
    id: 6,
    path: '/complianceEst/solutionDefinition',
    private: true,
    component: () => <SolutionDefinition />
  },
  {
    id: 7,
    path: '/complianceEst/tasksDefinition',
    private: true,
    component: () => <TasksDefinition />
  },
  {
    id: 8,
    path: '/complianceEst/evidenceDefinition',
    private: true,
    component: () => <EvidenceDefinition />
  },
  {
    id: 9,
    path: '/dataManagement/auditFindings',
    private: true,
    component: () => <AuditFindingsManagement />
  },
  {
    id: 10,
    path: '/dataManagement/category',
    private: true,
    component: () => <CategoryManagement />
  },
  {
    id: 11,
    path: '/dataManagement/product',
    private: true,
    component: () => <ProductManagement />
  },
  {
    id: 12,
    path: '/forgot_pass',
    private: false,
    component: () => <ForgotPass />
  },
  {
    id: 13,
    path: '/reset_password',
    private: false,
    component: () => <ResetPass />
  },
  {
    id: 14,
    path: '/verify-login',
    private: false,
    component: () => <VerifyLogin />
  },
  {
    id: 15,
    path: '/reporting',
    private: false,
    component: () => <Reporting />
  },
  {
    id: 16,
    path: '/reporting/control-report',
    private: true,
    component: () => <ControlReport />
  },
  {
    id: 17,
    path: '/reporting/gaps-evidences',
    private: true,
    component: () => <GapsEvidences />
  },
  {
    id: 18,
    path: '/reporting/business-rules-audit-findings',
    private: true,
    component: () => <BusinessRulesAuditFindings />
  },
  {
    id: 19,
    path: '/dataManagement',
    private: false,
    component: () => <MainLayout />
  },
  {
    id: 20,
    path: '/workingAreaDetails/:selected',
    private: true,
    component: () => <MainLayout />
  },
  {
    id: 21,
    path: '/library',
    private: true,
    component: () => <Library />
  },
  {
    id: 22,
    path: '/library/reporting',
    private: true,
    component: () => <LibraryReporting />
  },
  {
    id: 23,
    path: '/library/data-entry',
    private: true,
    component: () => <LibraryDataEntry />
  },
  {
    id: 24,
    path: '/library/data-entry/:area',
    private: true,
    component: () => <DataEntryTable />
  },
  {
    id: 25,
    path: '/user_access',
    private: true,
    component: () => <UserAccess />
  },
  {
    id: 26,
    path: '/dataManagement/solutionType',
    private: true,
    component: () => <SolutionTypeManagement />
  },
  {
    id: 27,
    path: '/dataManagement/taskType',
    private: true,
    component: () => <TaskTypeManagement />
  },
  {
    id: 28,
    path: '/internal_controls',
    private: false,
    component: () => <MainLayout />
  },
  {
    id: 29,
    path: '/controlsAndRiskAllocation/risks',
    private: true,
    component: () => <Risks />
  },
  {
    id: 30,
    path: '/controlsAndRiskAllocation/controls',
    private: true,
    component: () => <Controls />
  },
  {
    id: 31,
    path: '/controlsAndRiskAllocation/businessProcesses',
    private: true,
    component: () => <Processes />
  },
  {
    id: 32,
    path: '/risk-controls/dnd',
    private: false,
    component: () => <InternalControlsDND />
  },
  {
    id: 33,
    path: '/super_admin',
    private: true,
    component: () => <SuperAdminRedirect />
  },
  {
    id: 34,
    path: '/controlsAndRiskAllocation/controlsTesting',
    private: true,
    component: () => <ControlsTesting />
  },
  {
    id: 35,
    path: '/controlsAndRiskAllocation/businessProcessesL1',
    private: true,
    component: () => <ProcessesL1 />
  },
  {
    id: 36,
    path: '/controlsAndRiskAllocation/businessProcessesL2',
    private: true,
    component: () => <ProcessesL2 />
  },
  {
    id: 37,
    path: '/controlsAndRiskAllocation/businessProcessesL3',
    private: true,
    component: () => <ProcessesL3 />
  },
  {
    id: 38,
    path: '/risk-controls/reportings',
    private: false,
    component: () => <ReportingRisksAndControls />
  },
  {
    id: 39,
    path: '/controlsAndRiskAllocation/allocation',
    private: false,
    component: () => <Allocation />
  },
  {
    id: 40,
    path: '/audit_findings_workflow',
    private: false,
    component: () => <AuditFindingWorkflow />
  },
  {
    id: 41,
    path: '/data_management_workflow',
    private: false,
    component: () => <DataManagementWorkflow />
  },
  {
    id: 42,
    path: '/audit_findings_table',
    private: false,
    component: () => <AuditFindingsMapping />
  },
  {
    id: 43,
    path: '/risk-controls/testings',
    private: false,
    component: () => <MainLayout />
  },
  {
    id: 44,
    path: '/risk-controls/inventories',
    private: false,
    component: () => <MainLayout />
  },
  {
    id: 45,
    path: '/risk-controls/allocation',
    private: false,
    component: () => <MainLayout />
  },
  {
    id: 46,
    path: 'controlsAndRiskAllocation/controlsTestingDesignEffectiveness',
    private: true,
    component: () => <DesignEffectivenessTesting />
  },
  {
    id: 47,
    path: '/who_am_i',
    private: true,
    component: () => <WhoAmI />
  },
  {
    id: 48,
    path: '/compliance_establishment',
    private: true,
    component: () => <ComplianceEst />
  },
  {
    id: 49,
    path: '/controlsAndRiskAllocation/processAllocation',
    private: false,
    component: () => <ProcessAllocation />
  },
  {
    id: 50,
    path: '/compliance/dashboard',
    private: false,
    component: () => <Dashboard />
  },
  {
    id: 51,
    path: '/who_am_i/organizational_context',
    private: false,
    component: () => <OrganizationalContext />
  },
  {
    id: 52,
    path: '/who_am_i/allocation',
    private: false,
    component: () => <WhoAmIAllocation />
  },
  {
    id: 53,
    path: 'controlsAndRiskAllocation/controlAttestation',
    private: true,
    component: () => <ControlAttestationTesting />
  },
  {
    id: 54,
    path: '/who_am_i/allocation/persons',
    private: false,
    component: () => <WhoAmIAllocationUsers />
  },
  {
    id: 55,
    path: '/dependency_bpr/risks_controls_gaps',
    private: false,
    component: () => <ProcessesReport />
  },
  {
    id: 56,
    path: '/dependencies/gaps_audits_solutions',
    private: false,
    component: () => <GapsAuditSolutionsReport />
  },
  {
    id: 57,
    path: '/dependencies/evidences',
    private: false,
    component: () => <BRUEvidencesReport />
  },
  {
    id: 58,
    path: '/dependencies',
    private: false,
    component: () => <Dependencies />
  },
  {
    id: 59,
    path: '/dependency_bpr/processes',
    private: false,
    component: () => <BusinessProcessReport />
  },
  {
    id: 60,
    path: '/dependency_bpr',
    private: false,
    component: () => <DependenciesBPR />
  }
];

export const PROCESS_NAVIGATION_BUTTONS = [
  {
    labelKey: 'PROCESS_L1',
    path: '/controlsAndRiskAllocation/businessProcessesL1'
  },
  {
    labelKey: 'PROCESS_L2',
    path: '/controlsAndRiskAllocation/businessProcessesL2'
  },
  {
    labelKey: 'PROCESS_L3',
    path: '/controlsAndRiskAllocation/businessProcessesL3'
  },
  {
    labelKey: 'PROCESS_L4',
    path: '/controlsAndRiskAllocation/businessProcesses'
  }
];

export default routes;
